import type { WorkingTime, WorkingTimeDto } from '../types';

function formatTime(value: string | null | undefined): string {
  return value?.slice(0, 5) ?? '';
}

export function workingTimeFromDto(workingtime: WorkingTimeDto): WorkingTime {
  return {
    id: workingtime.id,
    weekDay: workingtime.dewt_weekday,
    startTime: formatTime(workingtime.dewt_start_time),
    endTime: formatTime(workingtime.dewt_end_time),
  };
}
